import React, {useMemo} from 'react'

import {AnalyticsDataContext} from './AnalyticsDataContext'

type Props<T extends object> = React.PropsWithChildren & {
  analyticsData: T
}

export const AnalyticsDataContextProvider = <T extends object>({
  children,
  analyticsData
}: Props<T>) => {
  const context = useMemo(() => ({analyticsData}), [analyticsData])
  return <AnalyticsDataContext.Provider value={context}>{children}</AnalyticsDataContext.Provider>
}
